import { create } from "zustand";
import { logout_V1 } from "../api/auth/authApi";

const useUserStore = create((set) => {
  return {
    user: localStorage?.getItem("user")
      ? JSON.parse(localStorage?.getItem("user"))
      : undefined,
    isLoggedIn: localStorage?.getItem("user")
      ? !!JSON.parse(localStorage?.getItem("user"))
      : undefined,
    setUser: (data) => {
      set((state) => {
        localStorage.setItem(
          "user",
          JSON.stringify({ ...state.user, ...data })
        );
        return { user: { ...state.user, ...data }, isLoggedIn: true };
      });
    },
    login: (userData) => {
      localStorage.setItem("user", JSON.stringify(userData));
      set({ user: userData, isLoggedIn: true });
    },
    logout: async () => {
      await logout_V1();
      localStorage.clear();
      set({ user: null, isLoggedIn: false });
    },
  };
});

const useUserProfileStore = create((set) => {
  return {
    profileDetail: null,
    setProfileDetail: (data) => set({ profileDetail: data }),
    updateProfileDetail: (data) =>
      set((state) => ({ profileDetail: { ...state.profileDetail, ...data } })),
  };
});

const useWorkspaceStore = create((set) => {
  const selectedWorkspace = localStorage?.getItem("selectedWorkspace");
  const parsedSelectedWorkspace =
    selectedWorkspace && selectedWorkspace !== "undefined"
      ? JSON?.parse(selectedWorkspace)
      : undefined;
  return {
    selectedWorkspace: parsedSelectedWorkspace,
    workspaceList: [],
    setWorkspaceList: (list) => set({ workspaceList: list }),
    selectWorkspace: (workspace) => {
      set((state) => {
        localStorage?.setItem("selectedWorkspace", JSON.stringify(workspace));
        return {
          selectedWorkspace: workspace,
          workspaceList: state?.workspaceList,
        };
      });
    },

    UpdateWorkspace: (workspace) => {
      set((state) => {
        localStorage?.setItem(
          "selectedWorkspace",
          JSON.stringify({
            ...state?.selectedWorkspace,
            ...workspace,
          })
        );
        return {
          selectedWorkspace: {
            ...state?.selectedWorkspace,
            ...workspace,
          },
          workspaceList: state?.workspaceList,
        };
      });
    },
  };
});

const useSubworkspaceStore = create((set) => {
  const selectedSubWorkspace = localStorage?.getItem("selectedSubWorkspace");
  const parsedSelectedSubWorkspace =
    selectedSubWorkspace && selectedSubWorkspace !== "undefined"
      ? JSON?.parse(selectedSubWorkspace)
      : undefined;
  return {
    selectedSubWorkspace: parsedSelectedSubWorkspace,
    subWorkspaceList: [],
    SubWorkspaceUser: [],
    setSubWorkspaceUser: (list) => set({ SubWorkspaceUser: list }),
    setSubWorkspaceList: (list) => set({ subWorkspaceList: list }),
    selectSubWorkspace: (subWorkspace) => {
      set((state) => {
        localStorage.setItem(
          "selectedSubWorkspace",
          JSON.stringify(subWorkspace)
        );
        return {
          selectedSubWorkspace: subWorkspace,
          subWorkspaceList: state?.subWorkspaceList,
          SubWorkspaceUser: state?.SubWorkspaceUser,
        };
      });
    },
    UpdateSubWorkspace: (subWorkspace) => {
      set((state) => {
        localStorage?.setItem(
          "selectedSubWorkspace",
          JSON.stringify({
            ...state?.selectedSubWorkspace,
            ...subWorkspace,
          })
        );
        return {
          selectedSubWorkspace: {
            ...state?.selectedSubWorkspace,
            ...subWorkspace,
          },
          subWorkspaceList: state?.subWorkspaceList,
          SubWorkspaceUser: state?.SubWorkspaceUser,
        };
      });
    },
  };
});

const useDebatesStatusStore = create((set, get) => {
  const currentForumStatus = localStorage?.getItem("currentForumStatus");
  const parsedCurrentForumStatus =
    currentForumStatus && currentForumStatus !== "undefined"
      ? JSON?.parse(currentForumStatus)
      : undefined;

  const allForumStatus = localStorage?.getItem("allForumStatus");
  const parsedAllForumStatus =
    allForumStatus && allForumStatus !== "undefined"
      ? JSON?.parse(allForumStatus)
      : undefined;

  return {
    currentForumStatus: parsedCurrentForumStatus || null,
    allForumStatus: parsedAllForumStatus || null,
    setCurrentForumStatus: (data) =>
      set((state) => {
        if (!data) return {}; // ❌ Do not update if data is null/undefined
        localStorage?.setItem(
          "currentForumStatus",
          JSON.stringify({
            ...data,
          })
        );
        return {
          currentForumStatus: {
            ...data,
          },
          allForumStatus: state?.allForumStatus,
        };
      }),
    // 🔹 Combined handler for new debate data
    handleNewDebateData: (data, id) => {
      set((state) => {
        if (!data) return;
        const updatedData = { ...state?.allForumStatus };

        Object.entries(data).forEach(([key, value]) => {
          if (key !== "forums") {
            updatedData[key] = value;
          }
        });

        if (data.forums) {
          updatedData.forums = updatedData.forums || {};

          Object.entries(data.forums).forEach(([forumId, forumData]) => {
            // Merge existing forum data with new updates (shallow merge)
            updatedData.forums[forumId] = {
              ...(updatedData.forums[forumId] || {}), // Preserve existing data if any
              ...forumData, // Apply updates from socket
            };
          });
        }
        // 1. Merge and update allForumStatus
        localStorage?.setItem("allForumStatus", JSON.stringify(updatedData));
        // 2. Update currentForumStatus from subWorkspace
        const currentForum = updatedData?.forums?.[id];
        if (currentForum) {
          localStorage?.setItem(
            "currentForumStatus",
            JSON.stringify(currentForum)
          );
        }
        return {
          currentForumStatus: currentForum,
          allForumStatus: updatedData,
        };
      });
    },
    setAllForumStatus: (data) =>
      set((state) => {
        if (!data) return {}; // ❌ Do not update if data is null/undefined
        localStorage?.setItem(
          "allForumStatus",
          JSON.stringify({
            ...data,
          })
        );
        return {
          currentForumStatus: state?.currentForumStatus,
          allForumStatus: {
            ...data,
          },
        };
      }),
  };
});

export {
  useDebatesStatusStore,
  useSubworkspaceStore,
  useUserProfileStore,
  useUserStore,
  useWorkspaceStore,
};
